import { appendLenskartInPriceName } from '../../../../own-days/helper';
import { removeParameterFromUrl } from '../../../../utils/helper';

/**
 * Prepare the local object.
 * @param {Object} filterMater - The filter data object.
 * @param {Object} TempData - Temporary data object.
 * @param {string} name - The name to filter.
 * @returns {Object} The prepared local object.
 */
const prepareLocalObj = (filterMater, TempData, name) => {
  let localObj = {};
  if (Object.keys(filterMater).length) {
    if (name in filterMater) {
      delete filterMater[name];
    }
  }

  if (Object.keys(filterMater).length !== 0) {
    localObj = filterMater;
  } else if (TempData) {
    localObj = TempData;
    if (Object.keys(localObj).length !== 0) {
      if (name in localObj) {
        delete localObj[name];
      }
    }
  }

  return localObj;
};

/**
 * Prepare the API local object.
 * @param {Object} apiTempData - API temporary data object.
 * @param {Object} localObj - The local object.
 * @param {string} name - The name to filter.
 * @param {Array} array - The array to filter.
 * @returns {Object} The prepared API local object.
 */
const prepareApiLocalObj = (apiTempData, localObj, name, array) => {
  let apilocalObj = {};

  if (Object.keys(apiTempData).length !== 0) {
    apilocalObj = apiTempData;
  } else {
    Object.keys(localObj).forEach(data => {
      apilocalObj[`filter_${data}`] = localObj[data];
    });
  }
  if (apiTempData || Object.keys(apilocalObj).length !== 0) {
    if (Object.keys(apilocalObj).length === 0) {
      apilocalObj = apiTempData;
    }
    if (name in apilocalObj) {
      delete apilocalObj[name];
    }
  }
  if (name in localObj && Object.keys(localObj).length !== 0) {
    localObj[name].push(array[0]);
  } else {
    localObj[name] = array;
  }
  apilocalObj[`filter_${appendLenskartInPriceName(name)}`] = array;
  if (localObj[name].length === 0) {
    delete localObj[name];
  }
  if (apilocalObj[`filter_${appendLenskartInPriceName(name)}`].length === 0) {
    delete apilocalObj[`filter_${appendLenskartInPriceName(name)}`];
  }

  return { apilocalObj };
};

/**
 * Prepare the string representation of filters.
 * @param {Object} localObj - The local object.
 * @returns {string} The string representation of filters.
 */
const prepareQueryString = localObj => {
  let mystring = '';
  const incLimit = Object.keys(localObj).length;

  Object.keys(localObj).forEach((key, parentIndex) => {
    let mystring2 = '';
    mystring += key.replace(/\s+/, '_');
    localObj[key].forEach((val, index) => {
      if (index === localObj[key].length - 1) {
        mystring2 += val.childid;
      } else {
        mystring2 = `${mystring2 + val.childid},`;
      }
    });
    if (typeof localObj[key][0] === 'undefined') {
      mystring += '';
    } else if (parentIndex === incLimit - 1) {
      mystring = `${mystring}=${mystring2}`;
    } else {
      mystring = `${mystring}=${mystring2}&`;
    }
  });

  return mystring;
};

/**
 * Filter Helper Function.
 * @param {string} name - The name to filter.
 * @param {Object} FilterDataObj - The filter data object.
 * @param {Object} TempData - Temporary data object.
 * @param {Object} apiTempData - API temporary data object.
 * @param {Array} array - The array to filter.
 * @param {Object} categoryActions - Category actions object.
 * @param {function} loadCatData - Function to load category data.
 */
export const filterHelper = (
  name,
  FilterDataObj,
  TempData,
  apiTempData,
  array,
  categoryActions,
  loadCatData
) => {
  const newName = name === 'filter_lenskart_price' ? 'price' : name;
  const filterMater = FilterDataObj;
  const localObj = prepareLocalObj(filterMater, TempData, newName);

  let queryString = '';

  const { apilocalObj } = prepareApiLocalObj(apiTempData, localObj, newName, array);

  categoryActions.addFilterData(localObj);
  categoryActions.handleFilterFunc(filterHelper);

  queryString = prepareQueryString(localObj);

  if (location.hash.includes('dir') && queryString.length) {
    const loc = location.hash.slice(
      location.hash.lastIndexOf('dir'),
      location.hash.lastIndexOf('true') + 4
    );
    let temp = loc;
    if (loc.includes('#')) {
      temp = loc.split('#')[1];
    }
    queryString = `${queryString}&${temp}`;
  } else if (location.hash.includes('dir') && !queryString.length) {
    const loc = location.hash.slice(
      location.hash.lastIndexOf('dir'),
      location.hash.lastIndexOf('true') + 4
    );
    let temp = loc;
    if (loc.includes('#')) {
      temp = loc.split('#')[1];
    }
    queryString += temp;
  }
  if (window.location.href?.indexOf('page=') !== -1) {
    const removePageParam = removeParameterFromUrl(window.location.href, 'page');
    history.pushState(window.location.href, null, `${removePageParam}#${queryString}`);
  } else {
    history.pushState('', '', `#${queryString}`);
  }
  const modTemp = {};
  modTemp.location = location;
  modTemp.location.hash = queryString;
  modTemp.counter = 1;
  categoryActions.modifyData(modTemp);
  loadCatData(apilocalObj);
  categoryActions.handleFilterFunc(filterHelper);
};

export function filterHelperMobileSelections({
  mobilePendingSelections = {},
  filterResult = [],
  setSelectedOptions,
  addFilterData,
  categoryID,
  getCategoryData,
  setShowFilterMobile,
}) {
  const newFilterDataObj = {};
  const updatedSelectedOptions = {};
  window.scrollTo(0, 0);

  const isClearAll = Object.values(mobilePendingSelections).every(arr => arr.length === 0);

  Object.entries(mobilePendingSelections).forEach(([filterId, optionIds]) => {
    const filter = filterResult.find(f => f.id === filterId);
    if (!optionIds.length || !filter) return;

    const options = filter.data?.[0]?.options || [];

    newFilterDataObj[filterId] = optionIds.map(optionId => {
      const option = options.find(o => String(o.id) === String(optionId));
      return {
        childid: option?.id,
        childname: option?.title,
      };
    });

    updatedSelectedOptions[filterId] = optionIds;
  });

  if (setSelectedOptions) {
    setSelectedOptions(updatedSelectedOptions);
  }

  if (addFilterData) {
    addFilterData(newFilterDataObj);
  }

  const currentParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));

  Array.from(currentParams.keys()).forEach(key => {
    if (key.startsWith('filter_') || key.includes('_id') || key.includes('price')) {
      currentParams.delete(key);
    }
  });

  if (!isClearAll) {
    const orderedFilterKeys = Object.keys(mobilePendingSelections);
    orderedFilterKeys.forEach(key => {
      const items = newFilterDataObj[key];
      if (!items) return;

      const ids = items.map(item => item.childid).join(',');
      currentParams.set(`filter_${key}`, ids);
    });
  }

  const filterKeys = [];
  const otherKeys = [];

  currentParams.forEach((val, key) => {
    const cleanKey = key.startsWith('filter_') ? key.replace(/^filter_/, '') : key;
    const param = `${cleanKey}=${val}`;

    if (key.startsWith('filter_') || key.includes('_id') || key.includes('price')) {
      filterKeys.push(param);
    } else {
      otherKeys.push(param);
    }
  });

  const displayParams = [...filterKeys, ...otherKeys];
  const newHash = displayParams.length ? `#${displayParams.join('&')}` : '';
  const newUrl = `${location.pathname}${newHash}`;
  history.replaceState('', '', newUrl);

  if (getCategoryData && categoryID !== undefined) {
    getCategoryData(categoryID, currentParams.toString());
  }

  if (setShowFilterMobile) {
    setShowFilterMobile(false);
  }
}
